export const links = {
  en: [
    { label: 'About', href: '/about' },
    { label: 'Process', href: '/process' },
    { label: 'Work', href: '/work' },
    { label: 'Careers', href: '/careers' },
    { label: 'Configurator', href: '/configurator' },
    { label: 'Contact us', href: 'mailto:contact@thegoodcode.io' }
  ],
  de: [
    { label: 'Über uns', href: '/about' },
    { label: 'Prozess', href: '/process' },
    { label: 'Arbeit', href: '/work' },
    { label: 'Karrieren', href: '/careers' },
    { label: 'Konfigurator', href: '/configurator' },
    { label: 'Kontakt', href: 'mailto:contact@thegoodcode.io' }
  ]
}
